import { useMemo } from 'react';
import Year3FoundationsTemplate from './templates/Year3FoundationsTemplate';
import { useCoursePricing } from '@/hooks/useCoursePricing';
import { useLocation } from '@/contexts/LocationContext';
import { buildFoundationsPage, type FoundationsPageKey } from '@/config/foundationsYearPages';

/** Config-driven WA / VIC Foundations year-level page. Prices come from course_pricing. */
export default function StateFoundationsYearPage(props: FoundationsPageKey) {
  const { selectedState, selectedCenterId } = useLocation();
  const { getPricingForYearRange } = useCoursePricing(
    props.state,
    'foundations',
    selectedState === props.state ? selectedCenterId || undefined : undefined,
  );
  const row = getPricingForYearRange(props.year, props.year);
  const price = row ? Number(row.price_per_session) : null;
  const books = row ? Number(row.books_cost ?? 0) : null;

  const page = useMemo(
    () => buildFoundationsPage(props, { pricePerSession: price, booksCost: books }),
    [props.state, props.year, props.subject, price, books],
  );

  return <Year3FoundationsTemplate key={page.route} page={page} />;
}
